import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { update } from '@tweenjs/tween.js';
import { TranslationProvider } from './locale/context';
const root = ReactDOM.createRoot(document.getElementById('root'));

function animate(time) {
	requestAnimationFrame(animate);
	update(time);
}
animate(animate);

root.render(
	<React.StrictMode>
		<TranslationProvider>
			<App />
		</TranslationProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
